var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:{ colored: _vm.colored, multiline: _vm.multiline, 'content-button': _vm.contentButton, active: _vm.active, disabled: _vm.disabled },attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":_vm.clicked}},[(!_vm.to)?_vm._t("default"):_c('router-link',{attrs:{"to":_vm.to}},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }